import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Radio, RadioGroup } from 'edenred-ui';
import { useController, useFormContext } from 'react-hook-form';

import { ICreateBenefitGroupForm } from '@epi-models/pages/BenefitGroups';
import { FundsLoadingTypes } from '@epi-constants/benefitTypes';
import { required } from '@epi-helpers/formHelpers/validators';
import { createRules } from '@epi-forms/helpers';
import { LunchFundsLoadingValues } from '@epi-models/pages/Home';

type FundsLoadingTypeProps = {
  disabled: boolean;
  fundsLoadingType?: LunchFundsLoadingValues;
};

const FundsLoadingType = ({
  disabled,
  fundsLoadingType
}: FundsLoadingTypeProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext<ICreateBenefitGroupForm>();

  const name = 'benefitSettings.lunch.fundsLoadingType';

  const rules = createRules([required]);

  const {
    field: { value, onChange: setValue }
  } = useController({
    name,
    control,
    rules
  });

  useEffect(() => {
    if (!value && fundsLoadingType) {
      setValue(fundsLoadingType);
    }
  }, [value, fundsLoadingType]);

  return (
    <RadioGroup value={value ?? fundsLoadingType} onChange={setValue}>
      <FormControlLabel
        value={FundsLoadingTypes.TopUpRequest}
        control={<Radio />}
        label={t(
          'components.manage_benefits.loading_type_field.labels.top_up_request'
        )}
        disabled={disabled}
      />
      <FormControlLabel
        value={FundsLoadingTypes.DirectLoad}
        control={<Radio />}
        label={t(
          'components.manage_benefits.loading_type_field.labels.direct_load'
        )}
        disabled={disabled}
      />
    </RadioGroup>
  );
};

export { FundsLoadingType };
